module.exports = __webpack_public_path__ + "fonts/Fontfabric - Uni Sans SemiBold.e9930c97.ttf";